export default __webpack_public_path__ + "static/media/Hero.bc24e7f7.png";